import React, { useEffect, useState } from "react"; 
import img1 from '../../../Assets/footer_images/img1.jpg';
import img2 from '../../../Assets/footer_images/img2.jpg';
import img3 from '../../../Assets/footer_images/img3.jpg';
import img4 from '../../../Assets/footer_images/img4.jpg';
import img5 from '../../../Assets/footer_images/img5.jpg';
import img6 from '../../../Assets/footer_images/img6.jpg';

import {
  FacebookFilled,
  TwitterSquareFilled,
  InstagramOutlined,
  PinterestFilled,
  YoutubeFilled,
  UpOutlined,
  TikTokFilled,
} from "@ant-design/icons";

import "./Footer.css";

const Footer: React.FC = () => {
  const [showFloating, setShowFloating] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowFloating(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    setIsScrolling(true);
    // Scroll window (standard case)
    window.scrollTo({ top: 0, behavior: "smooth" });
    // Also scroll document element & body as fallback for all browser/layout combinations
    document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
    document.body.scrollTo({ top: 0, behavior: "smooth" });
    // Reset the loading state after scroll animation completes
    setTimeout(() => setIsScrolling(false), 800);
  };

  return (
    <>
      {/* Instagram Gallery */}
      <div className="instagram-gallery">
        <div className="gallery-item"><img src={img1} alt="Gallery 1" /></div>
        <div className="gallery-item"><img src={img2} alt="Gallery 2" /></div>
        <div className="gallery-item"><img src={img3} alt="Gallery 3" /></div>

        {/* Overlay in center */}
        <div className="instagram-overlay">
          <p><a href="https://www.instagram.com/myjeevantech?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">@Jeevan on Instagram</a></p>
        </div>

        <div className="gallery-item"><img src={img4} alt="Gallery 4" /></div>
        <div className="gallery-item"><img src={img5} alt="Gallery 5" /></div>
        <div className="gallery-item"><img src={img6} alt="Gallery 6" /></div>
      </div>

      <hr className="divider" />

      {/* Footer Section */}
      <footer className="footer">
        <p>© 2025 <a href="https://jeevantech.in/" target="_blank" rel="noopener noreferrer">Jeevan Tech</a>, All Rights Reserved.</p>

        <div className="social-icons">
          <a href="https://www.instagram.com/myjeevantech?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"><FacebookFilled /></a>
          <a href="https://twitter.com/myjeevantech" target="_blank" rel="noopener noreferrer"><TwitterSquareFilled /></a>
          <a href="https://www.instagram.com/myjeevantech?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"><InstagramOutlined /></a>
          <a href="https://www.pinterest.com/myjeevantech/" target="_blank" rel="noopener noreferrer"><PinterestFilled /></a>
          <a href="https://www.tiktok.com/@myjeevantech" target="_blank" rel="noopener noreferrer"><TikTokFilled /></a>
          <a href="https://www.youtube.com/@myjeevantech" target="_blank" rel="noopener noreferrer"><YoutubeFilled /></a>
        </div>
      </footer>

      {/* Floating Back to Top Button */}
      {showFloating && (
        <button
          onClick={scrollToTop}
          className={`back-to-top-floating ${isScrolling ? "scrolling" : ""}`}
          aria-label="Scroll to top"
          title="Back to Top"
        >
          <UpOutlined />
        </button>
      )}
    </>
  );
};

export default Footer;
